<template>
  <div class="company-details" :class="'company-details--' + variant">
    <p v-if="variant === 'line'" class="company-details__line mb-0">
      {{ company.legalName }} · GSTIN {{ company.gstin }} · FSSAI
      {{ company.fssai }} · DPIIT {{ company.dpiit }}
    </p>

    <p v-else-if="variant === 'clause'" class="mb-0">
      {{ company.legalName }} (“{{ company.brand }}”) has its registered office
      at {{ registeredOffice }}. GSTIN: {{ company.gstin }}. FSSAI Licence No.:
      {{ company.fssai }}. DPIIT recognition number: {{ company.dpiit }}.
    </p>

    <ul v-else-if="variant === 'ids'" class="company-details__ids pl-0">
      <li v-for="item in registrations" :key="item.label">
        <span>{{ item.label }}</span>
        <strong>{{ item.value }}</strong>
        <a
          v-if="item.pdf"
          :href="item.pdf"
          target="_blank"
          rel="noopener noreferrer"
          class="company-details__pdf"
          :title="'View ' + item.label + ' certificate (PDF)'"
          :aria-label="'View ' + item.label + ' certificate (PDF, opens in a new tab)'"
        >
          <svg
            class="company-details__pdf-icon"
            viewBox="0 0 24 24"
            width="14"
            height="14"
            aria-hidden="true"
            focusable="false"
          >
            <path
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5zM14 3v5h5M9 13h6M9 17h6"
            />
          </svg>
          <span>View</span>
        </a>
      </li>
    </ul>

    <div v-else class="company-details__registry">
      <p class="mb-1"><strong>{{ company.legalName }}</strong></p>
      <p class="mb-4">{{ registeredOffice }}</p>
      <div
        v-for="item in registrations"
        :key="item.label"
        class="company-details__row"
      >
        <span>{{ item.label }}</span>
        <strong>{{ item.value }}</strong>
        <a
          v-if="item.pdf"
          :href="item.pdf"
          target="_blank"
          rel="noopener noreferrer"
          class="company-details__pdf"
          :title="'View ' + item.label + ' certificate (PDF)'"
          :aria-label="'View ' + item.label + ' certificate (PDF, opens in a new tab)'"
        >
          <svg
            class="company-details__pdf-icon"
            viewBox="0 0 24 24"
            width="14"
            height="14"
            aria-hidden="true"
            focusable="false"
          >
            <path
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5zM14 3v5h5M9 13h6M9 17h6"
            />
          </svg>
          <span>View</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import AppConfig from "Constants/AppConfig";

export default {
  props: {
    variant: {
      type: String,
      default: "registry",
    },
  },
  data() {
    return {
      company: AppConfig.company,
    };
  },
  computed: {
    registeredOffice() {
      return this.company.addressLines.join(" ");
    },
    registrations() {
      return [
        {
          label: "GSTIN",
          value: this.company.gstin,
          pdf: this.company.docs.gstin,
        },
        {
          label: "FSSAI Licence No.",
          value: this.company.fssai,
          pdf: this.company.docs.fssai,
        },
        {
          label: "DPIIT Recognition",
          value: this.company.dpiit,
          pdf: this.company.docs.dpiit,
        },
      ];
    },
  },
};
</script>

<style scoped>
.company-details__line {
  color: inherit;
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: 0.01em;
}
.company-details__ids {
  list-style: none;
  margin: 12px 0 0;
}
.company-details__ids li {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  font-size: 14px;
}
.company-details__ids li > span {
  flex: 1 1 auto;
  min-width: 0;
}
.company-details__ids li strong {
  margin-left: auto;
  text-align: right;
}
.company-details__pdf {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-width: 64px;
  padding: 4px 10px;
  border: 1px solid rgba(60, 153, 0, 0.45);
  border-radius: 999px;
  background: #f4fbef;
  color: #2f7a00;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: 0.02em;
  text-decoration: none;
  white-space: nowrap;
  transition: background-color 0.15s ease, color 0.15s ease,
    border-color 0.15s ease;
}
.company-details__pdf:hover,
.company-details__pdf:focus-visible {
  background: #3c9900;
  border-color: #3c9900;
  color: #fff;
  text-decoration: none;
}
.company-details__pdf:focus-visible {
  outline: 2px solid #3c9900;
  outline-offset: 2px;
}
.company-details__pdf-icon {
  flex: none;
}
.company-details__row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  font-size: 15px;
}
.company-details__row > span {
  flex: 1 1 auto;
  min-width: 0;
  color: #5c6560;
}
.company-details__row strong {
  margin-left: auto;
  text-align: right;
}
</style>
